module.exports = __webpack_public_path__ + "static/gallery_kerry_4-f2f86e5183da4a0dbfae172c5ac2cee1.jpg";